import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const state = {
  dadosRelatorio: [],
  conferencias: [],
  dadosChamada: {},
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
